import { IdentifiableObjectDTO } from '@dto/IdentifiableObjectDTO';

export class VisitTypeDTO extends IdentifiableObjectDTO<number> {
  public name: string;
}